import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeminiService } from '../gemini.service';

@Component({
    selector: 'app-aiassistantpopup',
    templateUrl: './aiassistantpopup.component.html',
    styleUrls: ['./aiassistantpopup.component.scss'],
    standalone: false
})
export class AiassistantpopupComponent {
  aggregatedContent = ""
  modelKey = "gemini-2.5-flash"
  completion = ""
  isAIThinking = false
  completionGenerated = false
  isReadOnly = false
  userId = ""
  prompt = ""
  organizationKey = "" // uwaga tu być może trzeba podstawiać currentOrganizationKey
  projectKey = "" // uwaga tu być może trzeba podstawiać currentProjectKey

  prefixes: {"action": string, "prefix": string}[] = [
    {"action": "Generate summary in a sentence", "prefix": "Create one sentence summary for the following passage of text in the language of these passages:\n\n\n"},
    {"action": "Generate summary in a paragraph", "prefix": "Create summary 3-5 sentences long for the following passage of text in the language of these passages:\n\n\n"},
    {"action": "Translate to English", "prefix": "Translate the following text into English:\n\n\n"},
    {"action": "Translate to Polish", "prefix": "Translate the following text into Polish:\n\n\n"},
    {"action": "Translate to French", "prefix": "Translate the following text into French:\n\n\n"},
    {"action": "Fix spelling and grammar", "prefix": "Fix spelling and grammar of the following passage of text and do in the language of the passage:\n\n\n"}
  ]

  constructor(public dialogRef: MatDialogRef<AiassistantpopupComponent>, @Inject(MAT_DIALOG_DATA) public data: {content: string, modelKey: string, completionGenerated: boolean, completion: string, isReadOnly: boolean}, private geminiService: GeminiService) {
    this.aggregatedContent = data.content
    this.isReadOnly = data.isReadOnly
    this.modelKey = data.modelKey
    if (this.modelKey == undefined) {
      this.modelKey = "gemini-2.5-flash"
    }
  }

  generateCompletion(prefix: string) {
    let prompt = prefix +" "+this.aggregatedContent
    this.isAIThinking = true
    this.geminiService.getGeminiResponse({prompt: prompt, history: [], enableGoogleSearchGrounding: false}, this.organizationKey, this.projectKey, this.userId, 1000, true, this.modelKey, 0).then(result => {
      this.completion = result
      this.isAIThinking = false
      this.completionGenerated = true
    })
  }

  close() {
    this.data.completionGenerated = false
    this.dialogRef.close();
  }

  save() {
    this.data.completionGenerated = true
    this.data.completion = this.completion
    this.dialogRef.close(this.data);
  }
}
